import * as XLSX from 'xlsx';
import {PropertyToTitle} from '../conversions/properties';
import {AO_KEY_2_TITLE} from '../../../features/auto-ordering/models/old-models/auto-order-types';

export function exportDataToExcel<DataType>(
  data: Record<string, DataType> | DataType[],
  fileName: string,
  sheetName: string,
  propertiesToExport: string[] = [],
): void {
  let dataArray: DataType[] = [];

  if (!Array.isArray(data)) {
    dataArray = Object.values(data);
  } else {
    dataArray = data;
  }

  if (dataArray.length === 0) {
    return;
  }

  let headers: string[] = Object.keys(dataArray[0])
    .filter((key: string): boolean =>
      propertiesToExport.length === 0 || propertiesToExport.includes(key),
    );

  const rows = dataArray.map((row: DataType) => {
    return headers.map((field: string) => {
      const value: DataType[keyof DataType] = row[field as keyof DataType];
      return value !== undefined && value !== null ? String(value) : '';
    });
  });

  headers = headers.map((key: string): string => String(PropertyToTitle[key] || AO_KEY_2_TITLE[key] || key));
  rows.unshift(headers);

  const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(rows);

  // eslint-disable-next-line @typescript-eslint/naming-convention
  const wb: XLSX.WorkBook = {Sheets: {[sheetName]: ws}, SheetNames: [sheetName]};

  const binaryData = XLSX.write(wb, {bookType: 'xlsx', type: 'binary'});

  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
  const arrayBuffer = new ArrayBuffer(binaryData.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < binaryData.length; i++) {
    uint8Array[i] = binaryData.charCodeAt(i) & 0xff;
  }
  const blob = new Blob([uint8Array], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});


  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
